module.exports = __webpack_public_path__ + "img/eu.c2488419.svg";